<div class="detail-page-card">
    <div class="detail-page-card-title">{{ "customFieldEditor.detailsTitle" | transloco }}</div>
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        @if (mainFormGroup) {
            <div class="form-group-styling" [formGroup]="mainFormGroup">
                <div class="row centered-row">
                    <div class="col-12 text-start">
                        <div class="form-group">
                            <label>{{ "customFieldEditor.nameLabel" | transloco }}</label>
                            <input
                                class="form-control form-control-sm"
                                name="nameInput"
                                formControlName="Name"
                                [required]="true"
                                [placeholder]="'customFieldEditor.requiredPlaceholder' | transloco"
                                inputTooltip
                            />
                        </div>
                        <div class="form-group">
                            <cerrix-checkbox
                                data-uiid="custom-field-editor-required"
                                formControlName="required"
                                [label]="'customFieldEditor.requiredLabel' | transloco"
                                fontsize="0.9em"
                            >
                            </cerrix-checkbox>
                        </div>
                        <div class="form-group">
                            <cerrix-checkbox
                                data-uiid="custom-field-editor-visible"
                                formControlName="visible"
                                [label]="'customFieldEditor.visibleLabel' | transloco"
                                fontsize="0.9em"
                            >
                            </cerrix-checkbox>
                        </div>
                        <div class="form-group">
                            <label>{{ "customFieldEditor.fieldTypeLabel" | transloco }}</label>
                            <ng-select
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="fieldType"
                                [required]="true"
                                [items]="fieldTypes"
                                [clearable]="false"
                                [multiple]="false"
                            >
                            </ng-select>
                        </div>
                    </div>
                </div>

                @if (showEditor) {
                    @let answerOptionsListName =
                        "customFieldEditor.answerOptionsListName" | transloco;
                    <div>
                        <ng-container
                            *ngComponentOutlet="
                                listManagerType;
                                inputs: { config: listConfigNamed(answerOptionsListName) }
                            "
                        ></ng-container>
                    </div>
                }
            </div>
        }
    </div>
</div>
